import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CardState, PortalActionRow } from "../card-types";

@Component({
  selector: "portal-actions-card",
  templateUrl: "./portal-actions-card.component.html",
  styleUrls: ["../../dashboard-section.scss", "../../dashboard-section-v2.scss"],
  styles: [":host { display: contents; }"],
})
export class PortalActionsCardComponent {
  @Input() title: string;
  @Input() hint: string;
  @Input() state: CardState<PortalActionRow>;
  @Input() noDataMessage: string = "Nothing to see here yet.";
  @Input() showExport: boolean = true;
  @Input() showDashboardLink: boolean = false;
  @Input() isReport: boolean = false;
  @Input() comingSoon: boolean = false;
  @Output() exportClick = new EventEmitter<void>();
  @Output() dashboardClick = new EventEmitter<void>();

  toggleRow(row: PortalActionRow) {
    if (row.children && row.children.length > 0) {
      row.expanded = !row.expanded;
    }
  }

  trackByIndex(index: number): number {
    return index;
  }
}
